import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const updatedToken = createAction(
  `${reduxKey}.REALTIME_UPDATED_TOKEN`,
  (token: string, expiresAt: number, waitingForToken: number) => ({
    token,
    expiresAt,
    waitingForToken,
  })
);

export const doShake = createAction(
  `${reduxKey}.REALTIME_DO_SHAKE`,
  (id: number) => ({ id })
);
